import { createTheme } from '@mui/material';

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#e91e63',
    },
  },
});

export default defaultTheme;
